import {Shift, ShiftEntity} from "../../../model/shift";
import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export type ShiftSelectorProps = {
  personId?: string
  vehicleId?: string
  trailerId?: string
  dateSort?: boolean
};

const getPersonIdParam = createParamSelector<ShiftSelectorProps | undefined, string | undefined>(params => params?.personId);
const getVehicleIdParam = createParamSelector<ShiftSelectorProps | undefined, string | undefined>(params => params?.vehicleId);
const getTrailerIdParam = createParamSelector<ShiftSelectorProps | undefined, string | undefined>(params => params?.trailerId);
const getDateSort = createParamSelector<ShiftSelectorProps | undefined, boolean | undefined>(params => params?.dateSort);


export const shiftsSelector = () => createSelector(
  [
    getUseQueryResultData<Shift[]>,
    getPersonIdParam,
    getVehicleIdParam,
    getTrailerIdParam,
    getDateSort,
  ],
  (
    data,
    personId,
    vehicleId,
    trailerId,
    dateSort,
  ) => {
    return selectShiftsAndTransform(
      data ?? [], {
        personId: personId,
        vehicleId: vehicleId,
        trailerId: trailerId,
        dateSort: dateSort
      }
    );
  }
);

export const shiftSelector = () => createSelector(
  [getUseQueryResultData<Shift>],
  (data) => {
    return data ? transformShift(data) : undefined;
  }
);

const sortShifts = (a: ShiftEntity | Shift, b: ShiftEntity | Shift): number => {
  if (typeof a.endDttm === "undefined" && typeof b.endDttm === "undefined") {
    return a.startDttm - b.startDttm;
  } else if (typeof a.endDttm === "undefined") {
    return -1;
  } else {
    return 1;
  }
};

export const selectShifts = (values?: Shift[], selector?: ShiftSelectorProps): Shift[] => {
  if (!values) {
    return [];
  }

  const filtered = values.filter((v) => {
    let filterIn = true;

    if (selector?.personId) {
      if (v.personId !== selector.personId) {
        filterIn = false;
      }
    }

    if (selector?.vehicleId) {
      if (v.vehicleId !== selector.vehicleId) {
        filterIn = false;
      }
    }

    if (selector?.trailerId) {
      if (v.trailerId !== selector.trailerId) {
        filterIn = false;
      }
    }

    return filterIn;
  });


  if (selector?.dateSort) {
    filtered.sort(sortShifts);
  }

  return filtered
};

export const transformShift = (value: Shift): ShiftEntity => {
  return ShiftEntity.from(value)
}

export const selectShiftsAndTransform = (values?: Shift[], selector?: ShiftSelectorProps): ShiftEntity[] => {
  const selected = selectShifts(values, selector);
  return selected.map(transformShift);
};
